module.exports = __webpack_public_path__ + "static/media/logo.a5c51378.png";